import Siema from './siema.min.js';

const init = () => {
  const setActiveClass = (navSelector) => {
    var elements = document.querySelectorAll(navSelector);
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove('active');
    }

    var element = document.querySelector(navSelector + '[data-slidenum="' + this.currentSlide + '"]');
    element.classList.add('active');
  }

  const grantSlider = new Siema({
    selector: '#grantarea-slider',
    duration: 400,
    loop: true,
  });
  grantSlider.goTo(0);
  setTimeout(() => { grantSlider.next(); }, 9000)

  const setupNavControl = (slider, selector) => {
    var elements = document.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('click', (e) => {
        slider.goTo(
          parseInt(e.target.dataset.slidenum),
          setActiveClass.bind(slider, selector)
        );
      });
    }
  }
  setupNavControl(grantSlider, '.grant-slider-nav');
};

init();



// WEBPACK FOOTER //
// ./site/html/assets/js/slider-init.js